document.addEventListener('keydown', function (e) {
  const active = document.activeElement
  if (!active.classList.contains('table-input')) return

  // fix for vertical navigation
  const preventVertical = active.classList.contains('prevent-vertical')
  if (preventVertical && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) return

  const td = active.closest('td')
  if (td) {
    const tr = td.closest('tr')
    const colIndex = Array.from(td.parentNode.children).indexOf(td)
    const rowIndex = Array.from(tr.parentNode.children).indexOf(tr)

    const rows = Array.from(tr.parentNode.children)
    let target

    switch (e.key) {
      case 'ArrowRight':
        target = tr.children[colIndex - 1]?.querySelector('.table-input')
        break
      case 'ArrowLeft':
        target = tr.children[colIndex + 1]?.querySelector('.table-input')
        break
      case 'ArrowDown':
        if (rowIndex === rows.length - 2) {
          // second to last row → go to first input of last row
          target = rows[rows.length - 1].querySelector('.table-input')
        } else {
          target = rows[rowIndex + 1]?.children[colIndex]?.querySelector('.table-input')
        }
        break
      case 'ArrowUp':
        target = rows[rowIndex - 1]?.children[colIndex]?.querySelector('.table-input')
        break
    }

    if (target) {
      target.focus()
      e.preventDefault()
    }
  }
})
